// Layout
const Layout = () => import(/* webpackChunkName: "group-admin" */ '@/views/AdminLayout.vue')
const AppBar = () => import(/* webpackChunkName: "group-admin" */ '@/components/layout/TheAdminAppBar.vue')
const NavigationDrawer = () =>
  import(/* webpackChunkName: "group-admin" */ '@/components/layout/TheAdminNavigationDrawer.vue')

// Store
import store from '@/store'

// Routes
const routes = [
  {
    path: '/admin',
    components: {
      default: Layout,
      appBar: AppBar,
      navigationDrawer: NavigationDrawer,
    },
    children: [
      {
        path: '',
        name: 'admin-dashboard',
        component: () => import(/* webpackChunkName: "group-admin" */ '@/views/AdminDashboard.vue'),
      },
      {
        path: 'surveys',
        name: 'admin-survey-list',
        component: () => import(/* webpackChunkName: "group-admin" */ '@/views/AdminSurveyList.vue'),
      },
    ],
  },
  {
    path: '/admin/surveys/:id',
    components: {
      default: Layout,
      appBar: AppBar,
      navigationDrawer: NavigationDrawer,
    },
    props: true,
    async beforeEnter(routeTo, routeFrom, next) {
      try {
        await store.dispatch('survey/init', routeTo.params.id)
        next()
      } catch (error) {
        console.error('beforeEnter', error)
      }
    },
    children: [
      {
        path: '',
        name: 'admin-survey-detail',
        component: () => import(/* webpackChunkName: "group-admin" */ '@/views/AdminSurveyDetail.vue'),
      },
      {
        path: 'preview',
        name: 'admin-survey-preview',
        component: () => import(/* webpackChunkName: "group-admin" */ '@/views/AdminSurveyDocument.vue'),
      },
      {
        path: 'export',
        name: 'admin-survey-records',
        component: () => import(/* webpackChunkName: "group-admin" */ '@/views/AdminSurveyRecords.vue'),
      },
    ],
  },
].map((route) => ({ ...route, meta: { requiresAuth: true } }))

export default routes
